"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CardRenderer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _imageCard = _interopRequireDefault(require("./image-card"));
var _mileageCard = _interopRequireDefault(require("./mileage-card"));
var _twoRowsCard = _interopRequireDefault(require("./two-rows-card"));
var _backgroundImageWithTextCard = _interopRequireDefault(require("./background-image-with-text-card"));
var cardTypes = {
  image: _imageCard["default"],
  mileage: _mileageCard["default"],
  dualRow: _twoRowsCard["default"],
  backgroundImageWithText: _backgroundImageWithTextCard["default"]
};
var CardRenderer = function CardRenderer(_ref) {
  var cardType = _ref.cardType,
    cardProps = _ref.cardProps,
    disclaimerData = _ref.disclaimerData;
  var CardComponent = cardTypes[cardType] || _imageCard["default"];
  return /*#__PURE__*/_react["default"].createElement(CardComponent, (0, _extends2["default"])({}, cardProps, {
    disclaimerData: disclaimerData
  }));
};
exports.CardRenderer = CardRenderer;